<span class="ribbon" [ngClass] = "_featuredFlag.color" [innerHTML]="flagHTML | safeHtml"></span>